/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import Table from '../../Table';
import { columnPropsForUsers } from './helper';
import './styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

const SupportCGM = ({ seletedSupport, onDelete }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    console.log('adminData ::::', seletedSupport);
    setData(seletedSupport);
  }, [seletedSupport]);
  const column = useMemo(
    () => [
      {
        dataIndex: 'email',
        label: 'Email',
        sort: (a, b) => {
          if (a.email < b.email) {
            return -1;
          }
          if (a.email > b.email) {
            return 1;
          }
          return 0;
        },
      },
      {
        dataIndex: 'action',
        label: 'Action',
        render: (_, datum, index) => {
          return (
            <Button outline color="danger" onClick={() => onDelete(datum, index)}>
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          );
        },
      },
    ],
    [data],
  );
  if (data)
  return (
    <div className="mt-3">
      <Table data={data} column={column} showPagination />
      <div className="mt-3 color-grey">
        <p>Total Support Engineer in Group: {seletedSupport?.length}</p>
      </div>
    </div>
  );
  else return null
};

export default SupportCGM;
